module.exports = __webpack_public_path__ + "img/footer-pay-mb.a1ab694.webp";